module.exports = __webpack_public_path__ + "static/media/Ellipse-2.fd1dd891.svg";